export const getFromMonth = (index) =>
  index === 0 ? new Date().getMonth() : new Date().getMonth() + 1;

export function getYears(selectedYear) {
  const previousYear = selectedYear - 1;
  return [selectedYear, previousYear];
}
